if(typeof LegalAgePopup !== 'function'){
  class LegalAgePopup extends HTMLElement {
    constructor() {
      super();
      this.expireCookie = parseInt(this.getAttribute('data-cookie-expires'));
      this.cookieName = this.getAttribute('data-cookie-name') || 'legal-age';
      this.button = this.querySelector('button');

      if(this.button.length == 0) return;

      this.button.addEventListener('click', this.onButtonClick.bind(this) );

      this.checkCookie();
      //this.openPopup();
    }

    checkCookie() {
      console.log(this.cookieName);
      if (!this.getCookie(this.cookieName)){
        this.openPopup();
        return;
      } 

      this.closePopup();
    }

    getCookie (name) {
      let value = `; ${document.cookie}`;
      let parts = value.split(`; ${name}=`);
      console.log(document.cookie);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    setCookie(name, value, expire) {
      document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * expire};`;
    }
    onButtonClick() {
      this.closePopup();
      this.setCookie(this.cookieName, true, this.expireCookie);
    }

    closePopup() {
      this.classList.add('hidden');
      document.body.style.overflow = 'auto';
    }
    openPopup() {
      this.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }

  }
  if(customElements.get('legal-age-popup') === undefined) 
    customElements.define('legal-age-popup', LegalAgePopup);
}